const TyreIndexExplanationLightboxActions = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
};

export { TyreIndexExplanationLightboxActions };
